import { FC, useEffect, useState } from 'react'
import {
  TablesWidget2,
  TablesWidget3,
  TablesWidget5,
} from '../../../_metronic/partials/widgets'
import { get_auth_user } from './DashboardApi'
import { useQuery } from 'react-query'
import { TablesWidgetLatestChart } from '../../../_metronic/partials/widgets/tables/TablesWidgetLatestChart'
import { permissionCheck } from '../../helper-functions/PermissionCheck'
import CalendarWidgetDashboard from '../../../_metronic/partials/widgets/tables/CalendarWidgetDashboard'
var appointment_create, appointment_edit, appointment_delete, appointment_activity_log, appointment_view;
const DashboardWrapper: FC = () => {
  const isPeopleCheck = !!(JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.user?.is_people ?? false)

  const { data: allAuthUser } = useQuery(
    'get_auth_user',
    get_auth_user,
    {
      refetchOnWindowFocus: false,
      enabled: !isPeopleCheck,
    }
  )

  const [AuthUserList, setAuthUserList] = useState<any[]>([])
  appointment_create = permissionCheck('appointment-create')
  appointment_edit = permissionCheck('appointment-update')
  appointment_delete = permissionCheck('appointment-delete')
  appointment_activity_log = permissionCheck('appointment-activity-log')
  appointment_view = permissionCheck('appointment-view')
  useEffect(() => {
    if (allAuthUser) {
      setAuthUserList(allAuthUser.data)
    }
  }, [allAuthUser])

  const isPeople = !!(JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.user?.is_people ?? false)

  return (
    <>
      <div className='row g-5'>
        {appointment_view && (
          <>
            <div className='col-md-6 col-12'>
              <TablesWidgetLatestChart className='card-xxl-stretch mb-5 mb-xxl-8' />
            </div>
            <div className='col-md-6 col-12'>
              <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' is_people={isPeople} />
            </div>
            <div className='col-md-6 col-12'>
              <TablesWidget3 className='card-xxl-stretch mb-5 mb-xxl-8' is_people={isPeople} />
            </div>
          </>
        )}
        {!isPeople && (
          <div className='col-md-12'>
            <TablesWidget2 className='card-xxl-stretch mb-5 mb-xxl-8' />
          </div>
        )}
      </div>
      <div className='row g-5'>
        <div className='col-md-12 col-12'>
          <CalendarWidgetDashboard />
        </div>
      </div>
    </>
  )
}

export { DashboardWrapper }
